import gql from "graphql-tag";
import CardHESP from "../../CardHESP/CardHESP";
import { useQuery } from "react-apollo";
import {
    GetV2ChannelsOfOrganization,
    GetV2ChannelsOfOrganizationVariables,
} from "./__generated__/GetV2ChannelsOfOrganization";
import Loading from "../../Loading/Loading";
import { Check, KeyboardDoubleArrowRightOutlined } from "@mui/icons-material";
import { navigate } from "@reach/router";

export const GET_V2_CHANNELS_OF_ORGANIZATION = gql`
    query GetV2ChannelsOfOrganization($organizationId: ID!) {
        getV2ChannelsOfOrganization(organizationId: $organizationId) {
            data {
                id
                externalId
                name
                timeout
                ads {
                    enabled
                }
                counts {
                    engines
                    ingests
                }
            }
        }
    }
`;

interface Props {
    organizationId: string;
}

export default function V2ChannelsOverview({ organizationId }: Props) {
    const { data, loading } = useQuery<GetV2ChannelsOfOrganization, GetV2ChannelsOfOrganizationVariables>(
        GET_V2_CHANNELS_OF_ORGANIZATION,
        { variables: { organizationId } },
    );

    if (loading) {
        return (
            <CardHESP>
                <Loading />
            </CardHESP>
        );
    }

    if (!data) {
        return <CardHESP>Could not get channels</CardHESP>;
    }

    return (
        <CardHESP>
            <div className="flex flex-col gap-3">
                {data.getV2ChannelsOfOrganization.data.length === 0 && (
                    <div className="italic text-gray-500 text-sm">No channels</div>
                )}
                {data.getV2ChannelsOfOrganization.data.map((channel) => (
                    <div
                        key={`channel-${channel.id}`}
                        className="flex flex-row justify-between border-[1px] border-slate-200 rounded-md px-3 py-2 cursor-pointer gap-x-8"
                        onClick={() => navigate(`/app/${organizationId}/v2-channels/${channel.id}`)}
                    >
                        <div className="flex flex-row justify-between w-full">
                            <div className="flex flex-col gap-1">
                                <div className="flex flex-row gap-1 items-end">
                                    <div className="font-semibold text-sm">{channel.name}</div>
                                    {channel.externalId && <div className="text-xs">({channel.externalId})</div>}
                                </div>
                                <div className="font-thin text-slate-400 text-xs">{channel.id}</div>
                            </div>
                            <div className="flex flex-row gap-3">
                                {channel.ads?.enabled === true && (
                                    <div>
                                        <div className="text-xs bg-green-50 rounded-md py-1 px-2 w-20 text-center">
                                            <Check color="inherit" style={{ fontSize: "14px" }} /> Ads
                                        </div>
                                    </div>
                                )}

                                <div>
                                    <div className="text-xs bg-blue-50 rounded-md py-1 px-2 w-20 text-center">
                                        {channel.counts?.engines ?? 0} engine{channel.counts?.engines !== 1 ? "s" : ""}
                                    </div>
                                </div>
                                <div>
                                    <div className="text-xs bg-purple-50 rounded-md py-1 px-2 w-20 text-center">
                                        {channel.counts?.ingests ?? 0} ingest{channel.counts?.ingests !== 1 ? "s" : ""}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <KeyboardDoubleArrowRightOutlined fontSize="small" className="text-yellow-400" />
                        </div>
                    </div>
                ))}
            </div>
        </CardHESP>
    );
}
